import { IonIcon } from "@ionic/react";
import classNames from "classnames/bind";
import { heart, heartOutline } from "ionicons/icons";
import React from "react";
import styles from "./MainPageProduct.module.scss";
import { Product } from "@core/types";
import { useConfig } from "../../../../../providers/config";
import { useWishListData } from "../../../../../providers/wishListStore";

interface WishlistButtonProps {
  product: Product;
}

const cx = classNames.bind(styles);

export const WishlistButton = ({ product }: WishlistButtonProps) => {
  const config = useConfig();
  const { toggleWish, isWishProduct } = useWishListData();

  return (
    <div
      className={cx(
        "productsSpecialLeft__heart",
        config?.cardProduct ? "productCommon__heart_irskom" : "productCommon__heart"
      )}
    >
      <div
        onClick={(e) => {
          toggleWish(product.id);
          e.stopPropagation();
        }}
      >
        <IonIcon
          className={cx("productHeartIcon")}
          color="primary"
          icon={isWishProduct(product.id) ? heart : heartOutline}
        />
      </div>
    </div>
  );
};
